let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1ierf")).then(() => parcelRequire('d3uR0'));